import { render, staticRenderFns } from "./cardDealCustom.vue?vue&type=template&id=ab5dcf28&scoped=true&"
import script from "./cardDealCustom.vue?vue&type=script&lang=js&"
export * from "./cardDealCustom.vue?vue&type=script&lang=js&"
import style0 from "./cardDealCustom.vue?vue&type=style&index=0&id=ab5dcf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5dcf28",
  null
  
)

export default component.exports